<template>
  <div v-if="state" tabindex="1" @click="closePreview" @keydown.prevent="closePreview" id="illustration-preview"
       class="fixed f-center-column">
    <div class="container-860 f-center"><img :src="require(`@/assets/${type}.webp`)" alt=""></div>

  </div>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Loader',
  props: { loaderType: { required: false, type: Object, default: () => null } },
  computed: {
    ...mapGetters({ state: 'getIllustrationPreviewStatus', type: 'getIllustrationPreviewType' }),
  },
  updated() {
    if (this.state) document.getElementById('illustration-preview').focus();
  },
  methods: {
    closePreview(e) {
      if (e.type === 'click' || (e.type === 'keydown' && e.code === 'Escape')) {
        this.$store.commit('SET_ILLUSTRATIONPREVIEW', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~union_styles/scss/variables";
@import "~union_styles/scss/helpers/mixins/position";

#illustration-preview {
  z-index: 1000000;
  @include same-top-left(0);
  width: 100vw;
  height: 100vh;
  background-color: rgba($color-background, 0.80);

  .container-860 {
    height: auto;

    img {
      max-width: 100%;
    }
  }
}
</style>
